import React from "react";
import "../css/Contact.css";

const Contact = () => {
  return (
    <div className="contact2">

      {/* HERO */}
      <section className="c2-hero">
        <div className="c2-hero-inner">
          <h1>CONNECT WITH FLEXOR</h1>
          <p>Precision. Power. Presence.</p>
        </div>
      </section>


      {/* CONTACT INFO BLOCK */}
      <section className="c2-info-section">

        <div className="c2-info-left">
          <h2>HEADQUARTERS</h2>
          <p className="c2-address">
            FLEXOR PERFORMANCE LAB<br />
            2748 Forge Street<br />
            Los Angeles, CA 90021
          </p>

          <div className="c2-details">
            <p><strong>Phone:</strong> +1 (323) 555-0149</p>
            <p><strong>Email:</strong> hello@FLEXORlab.co</p>
            <p><strong>Hours:</strong> Mon–Sun: 5AM – 11PM</p>
          </div>
        </div>

        <div className="c2-info-right">
          <div className="c2-map-wrapper">
            <iframe
              title="FLEXOR Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3303.728592387685!2d-118.24048772424048!3d34.03042497316411!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c75c6ddc3dfd%3A0xa0d9994b251eb0e8!2sArts%20District%20Los%20Angeles!5e0!3m2!1sen!2sus!4v1708900000000"
              loading="lazy"
              allowFullScreen=""
            ></iframe>
          </div>
        </div>

      </section>

    </div>
  );
};

export default Contact;
